<template>
  <div class="author-container">
    <div class="filter-main">
      筛选条件：
      <div class="filter-item">
        <label>h指数：</label>
        <el-select v-model="htIndex" placeholder="请选择" clearable @change="handleHtIndexSearch">
          <el-option v-for="item in htIndexList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>被引用次数：</label>
        <el-select v-model="citedByCount" placeholder="请选择" clearable @change="handleCitedByCountSearch">
          <el-option v-for="item in citedByCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
      <div class="filter-item">
        <label>作品数量：</label>
        <el-select v-model="worksCount" placeholder="请选择" clearable @change="handleWorksCountSearch">
          <el-option v-for="item in worksCountList" :key="item.value" :label="item.name" :value="item.value"></el-option>
        </el-select>
      </div>
    </div>
    <div class="search_total">
      <p class="total">
        <span>{{ listTotal }}</span
        >条作者数据
      </p>
    </div>
    <subject-list-skeleton v-if="loading" variant="author" />
    <ul v-else class="right-list">
      <li v-for="(item, index) in authorList" :key="index">
        <span class="right_index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
        <div class="right-content">
          <div class="title" @click="toAuthorDetail(item.sid)" v-safe-html="item.authorName"></div>
          <div class="num">
            <span><i class="el-icon-s-data"></i>H-index：{{ item.hindex }}</span>
            <span><i class="el-icon-s-comment"></i>论文数：{{ item.worksCount }}</span>
            <span><i class="el-icon-share"></i>引用数：{{ item.citedByCount }}</span>
          </div>
          <p v-if="item.lastKnownInstitutionName">所属机构：<span v-safe-html="item.lastKnownInstitutionName"></span></p>
          <p v-if="item.primayConcepts && item.primayConcepts.length > 0">
            研究领域：<span v-for="(element, idx) in item.primayConcepts" :key="idx"> <span v-safe-html="element"></span><span v-if="idx < item.primayConcepts.length - 1">；</span></span>
          </p>
        </div>
      </li>
    </ul>
    <div class="noData" v-if="total == 0 && !loading"><el-empty description="暂无数据"></el-empty></div>
    <el-pagination v-if="!loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total" hide-on-single-page> </el-pagination>
  </div>
</template>

<script>
import { EventBus } from "../../utils/eventBus";
import SubjectListSkeleton from "@/components/SubjectListSkeleton.vue";
export default {
  components: { SubjectListSkeleton },
  data() {
    return {
      subjectId: null,
      loading: true,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      listTotal: 0,
      authorList: [],

      htIndexList: [
        {
          name: "全部",
          value: "-",
        },
        {
          name: "h指数:<10",
          value: "-9",
        },
        {
          name: "h指数:10-19",
          value: "10-19",
        },
        {
          name: "h指数:20-29",
          value: "20-29",
        },
        {
          name: "h指数:30-39",
          value: "30-39",
        },
        {
          name: "h指数:40-49",
          value: "40-49",
        },
        {
          name: "h指数:50-59",
          value: "50-59",
        },
        {
          name: "h指数:>=60",
          value: "60-",
        },
      ],
      htIndex: "",
      htIndexStart: "",
      htIndexEnd: "",

      citedByCountList: [
        {
          name: "被引量大于1000",
          value: "1000-",
        },
        {
          name: "被引量500-1000",
          value: "500-1000",
        },
        {
          name: "被引量100-500",
          value: "100-500",
        },
        {
          name: "被引量50-100",
          value: "50-100",
        },
        {
          name: "被引量10-50",
          value: "10-50",
        },
      ],
      citedByCount: "",
      citedByCountStart: "",
      citedByCountEnd: "",

      worksCountList: [
        {
          name: "作品数量大于100",
          value: "100-",
        },
        {
          name: "作品数量50-100",
          value: "50-100",
        },
        {
          name: "作品数量30-50",
          value: "30-50",
        },
        {
          name: "作品数量10-30",
          value: "10-30",
        },
        {
          name: "作品数量小于10",
          value: "-10",
        },
      ],
      worksCount: "",
      worksCountStart: "",
      worksCountEnd: "",
    };
  },

  beforeDestroy() {
    // 组件销毁前移除事件监听，避免重复注册
    EventBus.$off("submitSubject");
  },

  mounted() {
    this.timer = setInterval(() => {
      // 检查是否已通过EventBus加载数据
      if (sessionStorage.getItem("subjectNodes")) {
        let id = JSON.parse(sessionStorage.getItem("subjectNodes")).id;
        this.getSubjectId(id);
      }
    }, 300);
    EventBus.$on("submitSubject", this.getSubjectId);
  },
  methods: {
    getSubjectId(id) {
      this.subjectId = id;
      window.clearInterval(this.timer);
      this.pageNo = 1;
      this.getAuthorList();
    },
    handleHtIndexSearch(val) {
      this.htIndex = val;
      let _val = this.htIndex.split("-");
      this.htIndexStart = _val[0];
      this.htIndexEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    handleCitedByCountSearch(val) {
      this.citedByCount = val;
      let _val = this.citedByCount.split("-");
      this.citedByCountStart = _val[0];
      this.citedByCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    handleWorksCountSearch(val) {
      this.worksCount = val;
      let _val = this.worksCount.split("-");
      this.worksCountStart = _val[0] ? _val[0] : "";
      this.worksCountEnd = _val[1] ? _val[1] : "";
      this.pageNo = 1;
      this.getAuthorList();
    },
    clearSearch() {
      this.htIndex = "";
      this.htIndexStart = "";
      this.htIndexEnd = "";

      this.worksCount = "";
      this.worksCountStart = "";
      this.worksCountEnd = "";

      this.citedByCountStart = "";
      this.citedByCountEnd = "";
      this.citedByCount = "";
      this.pageNo = 1;

      this.getAuthorList();
    },
    getAuthorList() {
      this.loading = true;
      let postBody = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        subjectId: this.subjectId,
        htIndexStart: this.htIndexStart,
        htIndexEnd: this.htIndexEnd,
        citedByCountStart: this.citedByCountStart,
        citedByCountEnd: this.citedByCountEnd,
        worksCountStart: this.worksCountStart,
        worksCountEnd: this.worksCountEnd,
      };
      this.$http({
        url: "api/v1/concept/author/list",
        method: "post",
        data: postBody,
      }).then(res => {
        this.loading = false;
        this.authorList = res.data.recordList;
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getAuthorList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getAuthorList();
    },
    toAuthorDetail(authorSid) {
      let _url = this.$router.resolve({
        path: "/authorDetail",
        query: { authorSid: authorSid },
      });
      window.open(_url.href, "_self");
    },
  },
};
</script>
<style lang="scss">
.el-select-dropdown__item.selected {
  color: #63ace5;
}
.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: #63ace5;
}
</style>
<style lang="scss" scoped>
@import "../../styles/public.scss";
.author-container {
  width: calc(100% - 40px);
  max-width: 1300px;
  min-width: 0;
  margin: 20px auto;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding-bottom: 0;

  .filter-main {
    flex-wrap: wrap;
    gap: 12px 20px;

    .filter-item {
      flex: 1 1 280px;
      min-width: 0;

      ::v-deep .el-select {
        flex: 1;
        min-width: 0;
        margin-right: 0;
      }

      ::v-deep .el-input {
        width: 100%;
      }
    }
  }

  .search_total {
    display: flex;
    align-items: center;
    .total {
      color: #86909c;
      span {
        color: #ff0000;
        margin-right: 5px;
      }
    }
    .search {
      margin-left: auto;
      width: 400px;
      position: relative;
      display: flex;
      align-items: center;
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      > span {
        background: #2d8cf0;
        height: 40px;
        width: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  .right-list {
    color: #666;
    li {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px dashed #eeeeee;
      .right_index {
        min-width: 36px;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .right-content {
        flex: 1;
        min-width: 0;
        font-size: 14px;
        .hover {
          cursor: pointer;
          color: #2d8cf0;
          &:hover {
            color: #2d8cf0 !important;
            text-decoration: underline;
          }
        }
      }
    }
    .title {
      color: #333;
      font-size: 16px;
      font-weight: 400;
      cursor: pointer;
      margin-bottom: 10px;
      &:hover {
        background-image: linear-gradient(to right, #006eb3, #2d8cf0);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        label {
          -webkit-text-fill-color: initial;
        }
      }
    }
    .num {
      margin-bottom: 8px;
      span {
        display: inline-block;
        margin-right: 15px;
        label {
          margin-left: 5px;
        }
        i {
          color: #ccc;
          margin-right: 5px;
        }
      }
    }
    p {
      margin-bottom: 8px;
    }
  }
  ::v-deep .el-pager li.active,
  ::v-deep .el-pager li:hover,
  ::v-deep .el-select .el-input.is-focus .el-input__inner,
  ::v-deep .el-pagination__sizes .el-input .el-input__inner:hover {
    color: #63ace5;
    border-color: #63ace5;
  }
  ::v-deep .el-pager li:hover {
    color: #63ace5;
  }
  ::v-deep .el-pagination button:hover {
    color: #63ace5;
  }
  ::v-deep .el-pagination__jump .el-input__inner:focus {
    border-color: #63ace5;
  }
}

@media (max-width: 768px) {
  .author-container {
    width: calc(100% - 24px);
    margin: 12px auto;
    padding: 16px 12px 0;

    .filter-main {
      align-items: stretch;
      gap: 10px;

      .filter-item {
        flex-basis: 100%;

        label {
          flex: 0 0 88px;
        }
      }
    }

    .right-list {
      li {
        padding: 16px 0;

        .right_index {
          min-width: 24px;
          margin-right: 6px;
        }

        .right-content {
          overflow-wrap: anywhere;
        }
      }

      .num {
        display: flex;
        flex-wrap: wrap;
        gap: 6px 12px;

        span {
          margin-right: 0;
        }
      }
    }

    ::v-deep .el-pagination {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      row-gap: 8px;
      padding: 16px 0;
      white-space: normal;
    }
  }
}
</style>
